<template>
  <div>
    <h3 class="topTitle">Información
      <b class="green">{{sectionName}}</b></h3>
    <div class="darkerRoundedBorder">
      <div class="roundedBorder maxWidth"
           @mouseenter="showInformationTab = true"
           @mouseleave="showInformationTab = false">
        <div class="progressBarContainer">
          <div
            class="progressBar">
            <div
              v-if="showInformationTab"
              class="informationTab"
              :style="`left: calc(${actualPercentage < 100 ? actualPercentage : 100}% - 125px);`">
              <div class="arrow-down"></div>
              <p class="small boldNumber grey">{{estimatedTotal}}
                <span class="showPercentage expectedStatic">{{estimatedPercentage}}%</span></p>
              <p class="small boldTitle">Esperado</p>
              <p class="small boldNumber">{{actualTotal}}
                <span
                  class="showPercentage"
                  :class="actualPercentage >= estimatedPercentage ? 'arrowUp' : 'arrowDown'">
                    {{actualPercentage}}%</span></p>
              <p class="small boldTitle">Actual</p>
            </div>
            <div
              class="progressExpected"
              :style="`width: ${estimatedPercentage}%`"></div>
            <div
              class="progressActual"
              :style="`width: ${actualPercentage < 100 ? actualPercentage : 100}%`"></div>
          </div>
        </div>
        <p class="boldTitle">Progreso Total Actual
          <b class="boldTitle green-text">{{fechaActual}}</b></p>
      </div>
      <div class="infoContainer">
        <div class="roundedBorder">
          <p class="boldNumber">{{orders}}</p>
          <p class="boldTitle">Ordenes</p>
        </div>
        <div class="roundedBorder">
          <p class="boldNumber">{{trucks}}</p>
          <p class="boldTitle">Vehículos</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    progressData: {
      type: Array,
      required: true,
    },
    sectionName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showInformationTab: false,
      estimatedPercentage: 4,
      actualPercentage: 10,
      estimatedTotal: 10,
      actualTotal: 4,
      trucks: 0,
      orders: 0,
      fechaActual: '',
    };
  },
  methods: {
    setData() {
      const now = new Date();
      this.fechaActual = moment(now).format('DD-MM-YYYY HH:mm');
      const first = this.progressData[0];
      this.orders = first.total_orders;
      this.actualTotal = first.estimated_progress.delivered + first.estimated_progress.rejected;
      this.actualPercentage = Math.round((this.actualTotal / this.orders) * 100);
      this.estimatedTotal = first.estimated_progress.in_route + this.actualTotal;
      if (first.vehicles != null) {
        this.trucks = first.vehicles;
      }
      // Set estimated Progress
      this.estimatedPercentage = Math.round((this.estimatedTotal / this.orders) * 100);
    },
  },
  beforeMount() {
    this.setData();
  },
  watch: {
    progressData() {
      this.setData();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/var";

  .darkerRoundedBorder {
    box-sizing: border-box;
    padding: 10px;
    width: 100%;
    border: 1px solid $fb-grey-light-84;
    margin: 0 auto;
    border-radius: 3px;
    background: $fb-grey-light-97;
    display: flex;
    justify-content: flex-end;
  }
  .topTitle {
    text-transform: uppercase;
    font-size: 16px;
    text-align: left;
    margin: 0 0 5px;
  }
  .roundedBorder {
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid $fb-grey-light-84;
    border-radius: 3px;
    background: white;
    display: inline-block;
  }
  .progressBarContainer {
    height: 34px;
    padding-top: 9px;
    box-sizing: border-box;
  }
  .progressBar {
    height: 20px;
    background: $fb-grey-light-94;
    position: relative;
  }
  .progressExpected {
    background: $fb-grey-light-50;
    height: 100%;
    position: absolute;
    transition: width 1s ease-in-out;
  }
  .progressActual {
    background: $fb-green;
    height: 100%;
    position: absolute;
    opacity: 0.7;
    transition: width 1s ease-in-out;
  }
  .informationTab {
    min-width: 145px;
    position: absolute;
    background: white;
    border: 1px solid $fb-grey-light-84;
    border-radius: 3px;
    bottom: 35px;
    padding: 10px;
    box-sizing: border-box;
    &::after {
      content: '';
      border-left: 12px solid transparent;
      border-right: 12px solid transparent;
      border-top: 12px solid white;
      position: absolute;
      bottom: -12px;
      right: 7px;
    }
    &::before {
      content: '';
      border-left: 13px solid transparent;
      border-right: 13px solid transparent;
      border-top: 13px solid $fb-grey-light-84;
      position: absolute;
      bottom: -13px;
      right: 6px;
    }
  }
  .boldTitle {
    text-transform: uppercase;
    font-size: 12px;
    color: $fb-grey-light-30;
    font-weight: 900;
    margin: 0;
    text-align: right;
    &.small {
      font-size: 10px;
    }
  }
  .green-text {
    color: $fb-green;
  }
  .boldNumber {
    font-size: 28px;
    font-weight: 900;
    margin: 0;
    color: $fb-green;
    text-align: right;
    &.small {
      font-size: 22px;
    }
  }
  .maxWidth {
    width: 100%;
  }
  .grey {
    color: $fb-grey-light-50;
  }
  .green {
    color: $fb-green;
  }
  .showPercentage {
    font-size: 11px;
    color: white;
    padding: 0 3px;
    &.arrowUp {
      background-color: $fb-green;
      &::after {
        content: ' \f062';
        font-family: FontAwesome;
      }
    }
    &.arrowDown {
      background-color: $fb-red;
      &::after {
        content: ' \f063';
        font-family: FontAwesome;
      }
    }
  }
  .infoContainer {
    display: flex;
    box-sizing: border-box;
    .roundedBorder {
      &:nth-of-type(1) {
        margin: 0 10px;
      }
    }
  }
  .expectedStatic {
    background: $fb-grey-light-50;
  }
  @media only screen and (max-width: 425px) {
    .progressBar {
      height: 10px;
    }
    .progressBarContainer {
      height: 25px;
    }
    .topTitle {
      font-size: 12px;
    }
    .darkerRoundedBorder {
      flex-direction: column;
    }
    .boldTitle {
      font-size: 10px;
    }
    .roundedBorder {
      padding: 5px 10px;
    }
    .boldNumber {
      font-size: 18px;
    }
    .boldTitle {
      font-size: 9px;
    }
    .infoContainer {
      margin-top: 10px;
      .roundedBorder {
        width: 100%;
        &:nth-of-type(1) {
          margin: 0 10px 0 0;
        }
        p {
          text-align: center;
        }
      }
    }
  }
</style>
